export default __webpack_public_path__ + "static/media/time.7e4d55d4.svg";